// Best Of Brazil Menu Section JS
let bobLog = "";

function updatePriceBasedOnLocationBob(price) {
  $(".geo-location-price").text(price);
  $(".skeleton-placeholder").removeClass(
    "best-of-brazil-inline-flex best-of-brazil-block"
  );
  $(".skeleton-placeholder").addClass("best-of-brazil-none");
  $(".price-para, .price-span").removeClass("best-of-brazil-none");

  bobLog += `price: ${price}`;
  consoleLogToPHP("updatePriceBasedOnLocationBob", bobLog);
}

function displayPriceBasedOnLocationBob(dataAddresses, finalAddresses) {
  // dataAddresses = {"default_price": "", "final_location_details": { "price": "", "geo_city": [] }}; // Sample data.
  let status = false;

  for (let finalAddress of finalAddresses) {
    if (dataAddresses.final_location_details.geo_city.includes(finalAddress)) {
      updatePriceBasedOnLocationBob(dataAddresses.final_location_details.price);
      status = true;
      break;
    }
  }

  if (!status) {
    updatePriceBasedOnLocationBob(dataAddresses.default_price);
  }
}

function isWithinRadiusBob(userLat, userLon, address, dataAddresses) {
  let city = "";
  let finalAddresses = [];
  let geocoder = new google.maps.Geocoder();
  let userLocation = new google.maps.LatLng(userLat, userLon);

  geocoder.geocode(
    {
      location: userLocation,
    },
    function (results, status) {
      if (status === "OK" && results[0]) {
        outerLoop: for (let i in results[0].address_components) {
          let component = results[0].address_components[i];
          switch (true) {
            case component.types.includes("locality"):
            case component.types.includes("sublocality"):
            case component.types.includes("sublocality_level_1"):
            case component.types.includes("sublocality_level_2"):
            case component.types.includes("sublocality_level_3"):
            case component.types.includes("sublocality_level_4"):
            case component.types.includes("sublocality_level_5"):
            case component.types.includes("administrative_area_level_1"):
            case component.types.includes("administrative_area_level_2"):
            case component.types.includes("administrative_area_level_3"):
            case component.types.includes("administrative_area_level_4"):
            case component.types.includes("administrative_area_level_5"):
            case component.types.includes("administrative_area_level_6"):
            case component.types.includes("administrative_area_level_7"):
            case component.types.includes("neighborhood"):
            case component.types.includes("postal_town"):
              if (!finalAddresses.includes(component.long_name)) {
                finalAddresses.push(component.long_name.toLowerCase()); // Get the city name, for example Atlanta.
              }
          }
        }
        displayPriceBasedOnLocationBob(dataAddresses, finalAddresses);
      } else {
        bobLog += `error_message: Geocode was not successful for the following reason: ${status}, `;
        updatePriceBasedOnLocationBob(dataAddresses.default_price);
      }
    }
  );
}

function getUserExactGeoLocationDetailsBob() {
  let pageURL = window.location.pathname;
  let dataAddresses = JSON.parse(
    getSessionStorage("getBOBMenuGeoLocationDetails")
  );

  let start = performance.now();

  navigator.geolocation.getCurrentPosition(
    (position) => {
      let end = performance.now();
      bobLog += `TimeTaken to detect the location by the browser: ${
        end - start
      } ms, `;
      let userLat = position.coords.latitude;
      let userLon = position.coords.longitude;

      // TODO: To be removed once after QA Testing.
      /* Test data starts*/
      if (
        dataAddresses.bob_geolocation_test_simulation
          .test_simulation_enabled === "1"
      ) {
        userLat = parseFloat(
          dataAddresses.bob_geolocation_test_simulation.latitude
        );
        userLon = parseFloat(
          dataAddresses.bob_geolocation_test_simulation.longitude
        );
      }
      /* Test data ends*/

      let searchedAddress = "Fogo de Chão Brazilian Steakhouse";

      bobLog += `userLat: ${userLat}, userLon: ${userLon}, `;

      isWithinRadiusBob(userLat, userLon, searchedAddress, dataAddresses);
    },
    (error) => {
      bobLog += `error_message: Error occurred. Error code: ${error.code}, `;
      updatePriceBasedOnLocationBob(dataAddresses.default_price);
    },
    { enableHighAccuracy: true }
  );
}

// Initialization.
$(document).ready(function () {
  getUserExactGeoLocationDetailsBob();
});
